// @ts-check
import React, { Fragment } from 'react';
import SelectExample from './SelectExample';
import SimpleTableExample from './SimpleTableExample';
import { Divider, Panel, PanelHeader, PanelMain, Stack } from '@patternfly/react-core';
import SimpleTablePagedExample from './SimpleTablePagedExample';
import PropertiesConditionEditorExample from './PropertiesConditionEditorExample';
import SimpleTableCheckboxExample from './SimpleTableCheckboxExample';

const Example = ({ title, children }) => {
  return (
    <Panel variant="raised">
      <PanelHeader>
        { title }
      </PanelHeader>
      <Divider />
      <PanelMain>
        { children }
      </PanelMain>
    </Panel>
  );
};

const examples = [
  {
    label: 'PropertiesConditionEditor',
    component: PropertiesConditionEditorExample
  },
  {
    label: 'SimpleTable',
    component: SimpleTableExample
  },
  {
    label: 'SimpleTable paged',
    component: SimpleTablePagedExample
  },
  {
    label: 'SimpleTable checkbox',
    component: SimpleTableCheckboxExample
  },
  {
    label: 'Select',
    component: SelectExample
  }
];

const ComponenTestPage = () => {
  return (
    <div style={{ overflow: 'auto', maxWidth: '1024px', height: '100%', padding: '10px' }}>
      <Stack hasGutter>
        { examples.map(({ label, component: Component }, index) => (
          <Fragment key={index}>
            <Example title={label}><Component /></Example>
            { index !== examples.length - 1 && <Divider /> }
          </Fragment>
        )) }
      </Stack>
    </div>
  );
};

export default ComponenTestPage;
